import {
  FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL,
  FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_FAILURE,
} from './types';

const initialState = {
  enabledFlagValues: [],
  plAccountValues: [],
  bsAccountValues: [],
  reclassPlAccountValues: [],
  reclassBsAccountValues: [],
  taxDescriptionNames: [],
  isFetchingInitialDataForModal: false,
};

function taxAccountingSettings(state = initialState, action) {
  switch (action.type) {
    case FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL:
      return {
        ...state,
        isFetchingInitialDataForModal: true,
      };
    case FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_SUCCESS:
      return {
        ...state,
        enabledFlagValues: action.enabledFlagValues,
        plAccountValues: action.accounts,
        bsAccountValues: action.accounts,
        reclassPlAccountValues: action.accounts,
        reclassBsAccountValues: action.accounts,
        taxDescriptionNames: action.taxDescriptionNames,
        isFetchingInitialDataForModal: false,
      };
    case FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_FAILURE:
      return {
        ...state,
        isFetchingInitialDataForModal: false,
      };
    default:
      return state;
  }
}

export default taxAccountingSettings;
